// extracted by mini-css-extract-plugin
export default {"numPeopleClaimingForPage":"NumPeopleClaimingFor_numPeopleClaimingForPage__8AKJX"};